import { IconBadgeProps } from './type';

import * as S from './styles';

const IconBadge: React.FC<IconBadgeProps> = ({
  show,
  value = '',
  max,
  children,
}) => {
  const maxPlus = `${max}+`;

  return (
    <S.Container data-testid="icon-badge">
      {children}
      {/* @ts-expect-error -- TODO: remove me. it should not be ignored, it started when we upgraded typescript to ^5 */}
      {show && <S.Badge>{max && value > max ? maxPlus : value}</S.Badge>}
    </S.Container>
  );
};

export default IconBadge;
